<template>

    <div class="galaxy::common-canvas-editor-Canvas tw-h-full" :class="activeMode == 'overview' ? 'tw-w-1/3' : 'tw-w-full'">

        <div
                v-if="activeMode == 'overview' && (canvasVersion.canvas_blocks.length == 0 || addInstruction.show)"
                class="tw-bg-white tw-border-1 tw-border-gray-500 tw-py-5 tw-px-5 tw-text-center tw-m-3 addInstruction"
                :class="{
                    saving: stateSaving,
                    hoveredForAddBlock: addInstruction.hoveredForAddBlock,
                }"
                @dragover.prevent="addInstruction.hoveredForAddBlock = true"
                @dragleave.prevent="addInstruction.hoveredForAddBlock = false"
                @drop.prevent="onInstructionDrop">

            <h5 class="tw-font-medium tw-text-lg tw-leading-normal tw-mb-0">Drag &amp; drop een blok<br />van rechts</h5>
            <div class="ttw-ext-xs tw-mt-1">(of klik het aan)</div>

        </div>

        <div
                class="zoomer"
                :style="{
                    transform: 'scale(' + scale + ')',
                    width: (100 / scale) + '%',
                    height: (100 / scale) + '%',
                 }">

            <div
                    class="tw-h-full"
                    :style="{
                        padding: activeViewport != 'xl' ? (24 / scale) + 'px ' + (16 / scale) + 'px' : 0,
                    }">

                <div class="tw-h-full tw-m-auto"
                     :style="{
                        maxWidth: activeMode != 'overview' ? viewportWidth + 'px' : '100%',
                     }">

                    <iframe-component
                            ref="iframe"
                            v-show="activeMode == 'content' || (activeMode == 'overview' && canvasVersion.canvas_blocks.length > 0)"
                            :canvasVersion="canvasVersion"
                            :scale="scale"
                            :activeMode="activeMode"
                            @loaded="$emit('loaded')"/>

                </div>

            </div>

        </div>


    </div>

</template>

<script>

    import Iframe from "./canvas/Iframe";
    import delay from "delay";

    // TODO Rename Canvas to ..?
    export default {

        provide: function() {
            return {
                canvasComponent: this,
            };
        },

        components: {
            'iframe-component': Iframe,
        },

        props: {
            canvasVersion: Object,

            activeMode: String,
            activeViewport: String,

            stateSaving: Boolean,
            galleryDraggingBlockId: String,
        },

        data()
        {
            return {
                scale: 1,

                selection: {
                    hovers: [],
                    focus: {
                        component: null,
                        extra: null,
                    },
                },

                addInstruction: {
                    show: false,
                    hoveredForAddBlock: false,
                },

            };
        },

        mounted()
        {
            this.manageScale();
        },

        methods:
        {
            manageScale()
            {
                // No scaling on canvas?
                if(this.activeMode != 'overview')
                    this.scale = 1;

                // Set scale to show an lg page?
                else
                    this.scale = Math.min($(this.$el).width() / 1500, 1);
            },

            onInstructionDrop()
            {
                // @ugly Call iframe
                this.$refs['iframe'].iframeApp.pageComponent.state.canvasVersion.canvas_blocks.push({
                    block: this.galleryDraggingBlockId,
                });
            },

        },

        computed:
        {
            instance()
            {
                return this;
            },

            viewportWidth() {
              // Full width due to XL?
              if (this.activeViewport === 'xl') {
                return 10000;
              }

              // Grab tailwind config for screens
              let tailwindConfig = require('./../../../../../../../../tailwind.config.js');

              // Get activeViewport screen size from tailwind config to get correct viewport px
              return parseInt(tailwindConfig.theme.screens[this.activeViewport].split('px')[0]);
            },

        },

        watch:
        {
            async 'activeMode'()
            {
                // @ugly To be able to get the correct new width.
                await delay(1);

                //
                this.manageScale();
            },

            /* TODO Low: See " // Keep showing add .."
            'canvasVersion.id'()
            {console.error('canvasVersion.id watcher');

                // Hide instruction by default.
                this.addInstruction.show = false;
            },

            'canvasVersion.canvas_blocks'(newVal, oldVal)
            {
                console.info('canvasVersion.canvas_blocks watchere');

                // Keep showing add instruction while saving the first block? Our state tells us we already have 1 block, but it is not visible on the screen yet.
                if(oldVal.length == 0 && newVal.length == 1)
                    this.addInstruction.show = true;
            },
            */

            'stateSaving'(newVal)
            {
                // Hide show add?
                if(this.canvasVersion.canvas_blocks.length > 0 && !newVal)
                    this.addInstruction.show = false;
            }
        }

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-Canvas {
        background: #ecf0f1;

        .addInstruction {
            border: 3px solid white;

            &.saving {
                cursor: wait;
                opacity: .6;
                transition: opacity .2s;

                > * {
                    pointer-events: none;
                }
            }

            &.hoveredForAddBlock {
                box-shadow: 0 0 20px rgba(0, 0, 0, 0.12), 0 0px 6px rgba(0, 0, 0, 0.12);
                border-color: #0888c8;
            }

        }

        .zoomer {
            transform-origin: left top;
        }

    }

</style>